const Tabs = () => {
  const tabsList = document.querySelector(".tabs__list")
  const tabsTitles = [...document.querySelectorAll(".tabs__item")];
  const tabsMains = [...document.querySelectorAll(".tabs__main")];
  const nextButtons = [...document.querySelectorAll(".next-btn")];
  
  if (tabsTitles.length > 0) {
    tabsTitles[0].classList.add("active");
    tabsMains[0].classList.add("active");

    tabsTitles.forEach((tabsTitle, index) => {
      tabsTitle.addEventListener("click", () => {
        tabsTitles.forEach((title, i) => {
          if (i !== index && tabsMains[i]) { 
            title.classList.remove("active");
            tabsMains[i].classList.remove("active");
          }
        });

        tabsTitle.classList.add("active");
        if (tabsMains[index]) { 
          tabsMains[index].classList.add("active");
        }
      });
    });

    nextButtons.forEach((nextButton, index) => {
      nextButton.addEventListener("click", () => {
        const nextIndex = (index + 1) % tabsTitles.length;
        
        tabsTitles.forEach((title, i) => {
          title.classList.remove("active");
          tabsMains[i].classList.remove("active");
        });

        tabsTitles[nextIndex].classList.add("active");
        tabsMains[nextIndex].classList.add("active");
      });
    });
  }

  if (tabsList) {
    if (tabsTitles.length === 2) {
      tabsList.classList.add("two-items");
    } 
    if (tabsTitles.length === 3) {
      tabsList.classList.add("three-items");
    } 
    if (tabsTitles.length === 4) {
      tabsList.classList.add("four-items");
    } 
  }
}

export default Tabs


